// Auto-generated normalizer for table: Certificaciones
export function certificacionesNormalize(row) {
  return {
    idCertificacion: row.idCertificacion ?? row.IdCertificacion ?? row['IdCertificacion'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    certificacionUrl: row.certificacionUrl ?? row.CertificacionUrl ?? row['CertificacionUrl'] ?? '',
    idFirma: row.idFirma ?? row.IdFirma ?? row['IdFirma'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
